import formatError from "@irati/utils/lang/formatError";
import codes from "../../errorCodes/User";
export default function tenantErrorHandler(err) {
    throw formatError(err, function (code) {
        switch (code) {
            case codes.TeamNotFoundErr:
                return "errors.PBIDETeamNotFound";
            case codes.TeamDoesNotBelong:
                return "errors.PBIDETeamDoesNotBelong";
            case codes.UserNotFoundErr:
                return "errors.PBIDEUserNotFound";
            case codes.EmailAlreadyExists:
                return "errors.PBIDEEmailAlreadyExists";
            case codes.EmailTooShort:
                return "errors.PBIDEEmailTooShort";
            case codes.EmailTooLong:
                return "errors.PBIDEEmailTooLong";
            case codes.EmailInvalid:
                return "errors.PBIDEEmailInvalid";
            case codes.RoleHierarchyCheckFailed:
                return "errors.PBIDERoleHierarchyCheckFailed";
            case codes.InvalidSettingKey:
                return "errors.PBIDEInvalidSettingKey";
            case codes.InvalidSettingType:
                return "errors.PBIDEInvalidSettingType";
            case codes.AddressValidationFailed:
                return "errors.PBIDEAddressValidationFailed";
            case codes.OneAddressMustBePrimary:
                return "errors.PBIDEOneAddressMustBePrimary";
            case codes.OnlyOnePrimaryAddress:
                return "errors.PBIDEOnlyOnePrimaryAddress";
            case codes.DOBInvalid:
                return "errors.PBIDEDOBInvalid";
            case codes.FirstnameTooShort:
                return "errors.PBIDEFirstnameTooShort";
            case codes.FirstnameTooLong:
                return "errors.PBIDEFirstnameTooLong";
            case codes.FirstnameInvalid:
                return "errors.PBIDEFirstnameInvalid";
            case codes.LastnameTooShort:
                return "errors.PBIDELastnameTooShort";
            case codes.LastnameTooLong:
                return "errors.PBIDELastnameTooLong";
            case codes.LastnameInvalid:
                return "errors.PBIDELastnameInvalid";
            case codes.GenderInvalid:
                return "errors.PBIDEGenderInvalid";
            case codes.PhoneTooShort:
                return "errors.PBIDEPhoneTooShort";
            case codes.PhoneTooLong:
                return "errors.PBIDEPhoneTooLong";
            case codes.PhoneInvalid:
                return "errors.PBIDEPhoneInvalid";
            case codes.SourceInvalid:
                return "errors.PBIDESourceInvalid";
            case codes.UserDisabled:
                return "errors.PBIDEUserDisabled";
            case codes.ProfileImageInvalid:
                return "errors.PBIDEProfileImageInvalid";
            default:
                return "";
        }
    });
}
